/* eslint-disable */
import React from 'react'
import {Checkbox, message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import MESSANGER from '../BaseComponent/MESSANGER'
import {Link} from 'react-router-dom'
import SearchableCombo from '../BaseComponent/searchableCombo'
import USER_MANAGE from '../BaseComponent/USERMANAGE'

class NewMessage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      checkAll: false,
      drivers: [],
      driverId: '',
      templates: [],
      title: '',
      content: '',
      receiverId: ''
    }
  }
  componentDidMount() {
    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }

          this.setState({
            drivers: response.data.object
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    http.get(`${MESSANGER.MESSAGING_TYPE_LIST_TEMPLATE}`, {}).then((response) => {
      if (response.data.error === null) {
        this.setState({
          templates: response.data.object
        })
      } else {
        this.setState({
          templates: []
        })
      }
    })
  }

  changeTemp(e) {
    let target = e.target
    let value = target.value
    if (value === '') {
      this.setState({
        title: '',
        content: ''
      })
    } else {
      this.setState({
        title: target.options[target.selectedIndex].getAttribute('data-title'),
        content: target.options[target.selectedIndex].getAttribute('data-content')
      })
    }
  }
  changeField(e) {
    let target = e.target
    let name = target.name
    let value = target.value
    this.setState({
      [name]: value
    })
  }

  sendMessage() {
    let {title, content, checkAll, driverId} = this.state
    let receiverId = driverId.personId === undefined || driverId.personId === null ? '' : driverId.personId
    var templateId = document.getElementById('templateId').value

    let broadcast = checkAll
    let titleError = false
    let contentError = false
    let sendError = false
    let formError = false

    if (checkAll === false && receiverId === '') {
      message.error('رساننده را مشخص کنید')
      sendError = true
      formError = true
    } else {
      if (!sendError) {
        this.setState({
          error: ''
        })
      }
    }

    if (title === '') {
      message.error('عنوان  را مشخص کنید')
      titleError = true
      formError = true
    } else {
      if (!titleError) {
        this.setState({
          error: ''
        })
      }
    }

    if (content === '') {
      message.error(' پیام را مشخص کنید')
      contentError = true
      formError = true
    } else {
      if (!contentError) {
        this.setState({
          error: ''
        })
      }
    }
    if (!formError) {
      let data = {
        title,
        content,
        broadcast,
        templateId: templateId === '' ? undefined : templateId,
        receiverId: this.state.checkAll ? undefined : receiverId
      }

      http.post(`${MESSANGER.MESSAGING_OPERATION_COMPANY_SEND}`, data, {}).then((response) => {
        if (response.data.error === null) {
          message.success('پیام با موفقیت ارسال شد')
          this.props.history.push('/messanger/report/send')
        } else {
        }
      })
    }
  }

  submit(e) {
    e.preventDefault()
  }

  changeCheckAll = (e) => {
    this.setState({
      checkAll: e.target.checked
    })
  }
  getValueDriver = (driverId) => {
    this.setState({
      driverId,
      receiverId: driverId.personId
    })
  }

  render() {
    return (
      <div className={'rtl'}>
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>پیام رسان</li>
            <li>ارسال پیام جدید</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>ارسال پیام جدید</p>
            </div>
            <div className="formComponent">
              <Checkbox defaultChecked={this.state.checkAll} onChange={this.changeCheckAll}>
                ارسال به همه
              </Checkbox>
            </div>

            <div className="formComponent">
              <SearchableCombo
                options={this.state.drivers}
                force={this.state.checkAll === true ? false : true}
                getValueCombo={this.getValueDriver}
                lableText="رساننده ها :"
                placeholder="------"
                isClearable={true}
                isMulti={false}
                isDisabled={this.state.checkAll ? true : false}
              />
            </div>

            <div className="formComponent">
              <label>پیام های آماده : </label>
              <select className="form-control" id="templateId" onChange={this.changeTemp.bind(this)}>
                <option value="">-----</option>
                {this.state.templates.map((temp, index) => (
                  <option key={index} value={temp.id} data-content={temp.content} data-title={temp.title}>
                    {temp.title}
                  </option>
                ))}
              </select>
            </div>

            <div className="formComponent">
              <label>
                عنوان : <span className="requireFiled">*</span>
              </label>
              <input
                typeof="text"
                defaultValue={this.state.title}
                name={'title'}
                onChange={this.changeField.bind(this)}
                className="form-control"
              />
            </div>

            <div className="formComponent">
              <label>
                پیام : <span className="requireFiled">*</span>
              </label>
              <textarea
                className="form-control"
                id="content"
                name="content"
                onChange={this.changeField.bind(this)}
                value={this.state.content}
              />
            </div>

            <div className="formComponent">
              <button className="btn btn-info btn-block" onClick={this.sendMessage.bind(this)}>
                ارسال پیام
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}
export default NewMessage
